//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------


export default class ConfirmEmailService extends APIService {
  async confirmEmail(token) {
    const route = API_ROUTES.confirm_email;
    return this.post(route, { token: token });
  }

}